import file from "../Markdown/Contact.md";
import React from "react";
import MarkdownPage from "../Layout/MarkdownPage";
import {Alert, Button} from "@mui/material";
import {Link} from "react-router-dom";

function Contact() {
    return (<MarkdownPage title='Kontakt' file={file}>
        <Alert severity="info" action={<Link to={'/faq'}><Button color={'info'} variant={'contained'}>Centrum Pomocy</Button></Link>}>Odpowiedzi na najczęściej zadawane pytania znajdziesz w</Alert>
    </MarkdownPage>);
}

export default Contact;